import React, { useMemo } from "react";
import { useTranslation } from 'react-i18next';
import { buildCloudinaryImageUrl } from "../../utils/CloudinaryImageUrl";

export default function WeeklyFavoritesSection({
  onOpenDetail = () => { },
  onAddToCart = () => { },
  products = [],
  limit = 5,
  title = "",
  selectProduct
}) {
  const { t } = useTranslation();

  const effectiveLimit = Number(limit) > 0 ? Number(limit) : 5;
  const hasCustomTitle = String(title || '').trim().length > 0;

  return (
    <section className="fv-section" style={{ paddingTop: 0 }}>
      <p className="fv-section-label">{t('home.weeklyLabel')}</p>
      <h2 className="fv-section-title" style={{ marginBottom: "2rem" }}>
        {hasCustomTitle ? title : <>{t('home.weeklyTitleLine1')}<br />{t('home.weeklyTitleLine2')}</>}
      </h2>

      <div className="fv-featured-scroll" aria-label={t('home.weeklyAria')}>
        {products.slice(0, effectiveLimit).map((p) => (
          <div
            onClick={() => selectProduct(p)}
            // key={p.id}
            className="fv-featured-card"
            role="button"
          // tabIndex={0}
          // onClick={() => onOpenDetail(p.id)}
          // onKeyDown={(e) => {
          //   if (e.key === "Enter" || e.key === " ") onOpenDetail(p.id);
          // }}
          >
            <div className="fv-featured-img-wrap">
              {/* <img
                className="fv-featured-img"
                src={p.img}
                alt={p.name}
                loading="lazy"
              /> */}

              <img

                className="fv-featured-img"             
                alt={p.name}
                loading="lazy"
                src={buildCloudinaryImageUrl({ url: p.img, width: 300, quality: "auto", type: "image" })}
                onError={e => e.target.style.opacity = 0}
              />
            </div>

            <div className="fv-featured-body">
              <p className="fv-featured-name">{p.name} </p>
              {/* <p className="fv-featured-category">{p.category}</p> */}

              <div className="fv-featured-footer">
                <span className="fv-featured-price">
                  ${p.price.toFixed(2)}
                </span>

                <button
                  type="button"
                  className="fv-featured-add-btn"
                  onClick={() => selectProduct(p)}
                  aria-label={`+ ${t('product.addToCart')}`}
                  title={`+ ${t('product.addToCart')}`}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
